import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  id: "planner-main-wrapper",
  class: "container px-0 px-md-3 bg-blue-100"
}
const _hoisted_4 = {
  key: 0,
  class: "col-12 px-0"
}
const _hoisted_5 = { class: "container px-0 text-center" }
const _hoisted_6 = { class: "title-2 text-grey-800" }

import { computed, ComputedRef, onMounted, watch } from "vue";
//import store from "@/vue/planning/store/store";
import documentReady from "@/vue/planning/logic/documentReady";
import useLocale from "@/vue/composables/useLocale";
import transportPackCode from "@/config/transportPackCode";

// components
import Search from "@/vue/planning/components/search.vue";
import Result from "@/vue/planning/components/result.vue";
import Summary from "@/vue/planning/components/summary.vue";
import TransportSwitch from "@/vue/planning/components/transportSwitch.vue";
import TrainTimeLine from "@/vue/planning/components/trainTimeLine.vue";
import OopsBanner from "@/vue/planning/components/oopsBanner.vue";
import Overlay from "@/vue/common/overlay.vue";
import ErrorMessage from "@/vue/planning/components/common/errorMessage.vue";

// computed
import availableTransportPackCodes from "@/vue/planning/computed/availableTransportPackCodes";

import { useStore } from "vuex";
interface Props {
	keyUpdater: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  props: {
    keyUpdater: {}
  },
  setup(__props: any) {

const store = useStore();

const props = __props;

const locale = useLocale();

const isTransportPackageSelected = computed(() => {
	return transportPackCode.includes(store.state.packCode);
});

// computed
const errorText: ComputedRef<string> = computed(() => {
	const val = store.state.content[store.state.errorMessageOpen];
	return val;
});

// methods
const handleErrorMessageClose = () => {
	store.commit("setErrorMessageOpen", "");
};

onMounted(async () => {
	await documentReady(store);
	window.addEventListener("closeMonCompteModal", async () => {
		await documentReady(store);
	});

	store.commit("setScreenType", window.screenSizeManager.screenType);
	window.addEventListener("screenTypeChange", () => {
		store.commit("setScreenType", window.screenSizeManager.screenType);
	});

	const triggerResize = () => {
		window.dispatchEvent(new Event('resize'));
	};

	triggerResize(); // initial
	window.addEventListener('orientationchange', triggerResize);
	window.addEventListener('resize', triggerResize);
});

// watch
watch(
	() => store.state.bodyOverflowHidden,
	(newValue: boolean) => {
		if (newValue) {
			document.body.classList.add("overflow-hidden");
		} else {
			document.body.classList.remove("overflow-hidden");
		}
	}
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "planner-app",
    class: "bg-blue-100 pb-4",
    key: props.keyUpdater
  }, [
    _createVNode(Overlay, {
      position: 'absolute',
      open: _unref(store).state.loading,
      color: '',
      maxOpacity: 1,
      contentTimeout: 110,
      classes: 'loader'
    }, {
      default: _withCtx(() => [
        (_unref(store).state.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open"]),
    (_unref(store).state.productUnavailable && !_unref(store).state.activePrestations)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(OopsBanner)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (!_unref(store).state.activePrestations)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("h2", null, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(store).state.content.planner_planVacation), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(availableTransportPackCodes).length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(TransportSwitch),
                _withDirectives(_createVNode(TrainTimeLine, null, null, 512), [
                  [_vShow, isTransportPackageSelected.value && _unref(locale) === 'fr_FR']
                ])
              ], 64))
            : _createCommentVNode("", true),
          (!_unref(store).state.activePrestations)
            ? (_openBlock(), _createBlock(Search, { key: 2 }))
            : _createCommentVNode("", true),
          _createVNode(Result),
          _createVNode(Summary)
        ])),
    _createVNode(ErrorMessage, {
      text: errorText.value,
      onClose: handleErrorMessageClose
    }, null, 8, ["text"])
  ]))
}
}

})